// src/components/TestimonialSection.tsx
import React from 'react';
import Carousel from './resuable-components/Carousel';
import image1 from './assets/sumit.webp';
import image2 from './assets/Neel2.webp';
import image3 from './assets/Raunak.webp';

const testimonials = [
  {
    image: image1,
    title: 'Sumit Suneja',
    content: 'Co-founder | Merlin Brands',
    quote:
      'EximPe helped me with compliance and advisory services for my China import business. Their support team is always at toes to help customers.',
  },
  {
    image: image2,
    title: 'Neel Garg',
    content: 'Owner | Neel Engineering',
    quote:
      "EximPe's FX payments is 100% digital. System is so transparent that I'm confident about getting the best rates in the market.",
  },
  {
    image: image3,
    title: 'Ronak Mistry',
    content: 'Director | Naps Trading',
    quote:
      "I'm saving around $500 per month using EximPe FX platform for my textile business, which I'm utilizing in marketing to get more business.",
  },
];

const TestimonialSection: React.FC = () => (
  <section
    className="
       pb-20
      bg-cover bg-center bg-no-repeat
    "
   
  >
    <div className="text-[#1A202C] max-w-6xl  mx-auto px-4 sm:px-8">
      <h2 className="text-center text-4xl font-bold text-gray-900 mb-12">
        Client Testimonials
      </h2>
      <Carousel
        items={testimonials}
        renderItem={(t, isCenter) => (
          <div
            className={`
              relative 
              bg-white/90       /* slight white overlay */
              rounded-2xl 
              p-12 pt-20 
              text-center 
              shadow-lg 
              w-80 h-96 
              flex-shrink-0
            `}
          >
            {/* avatar */}
            <div className="absolute left-1/2 -translate-x-1/2 top-1">
              <img
                src={t.image}
                alt={t.title}
                className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover"
              />
            </div>
            <h4
              className={`mt-4 text-lg font-semibold ${
                isCenter ? 'text-gray-900' : 'text-gray-700'
              }`}
            >
              {t.title}
            </h4>
            <p className="text-sm text-gray-600 mb-4">{t.content}</p>
            <blockquote className="italic text-gray-700 leading-relaxed overflow-auto h-40">
              “{t.quote}”
            </blockquote>
          </div>
        )}
      />
    </div>
  </section>
);

export default TestimonialSection;
